<template>
  <v-toolbar id="header" 
            :class="toolbarCss"
            elevation="0"
            dense>
   <v-toolbar-title 
     class="text-h6 primary--text font-weight-bold"
     @click="toggleAppMenu">
     {{ toolbarTitle }} 
     <v-icon v-if="hasOpenApps">
      mdi-chevron-down
     </v-icon>
   </v-toolbar-title>

   <v-spacer></v-spacer>

   <!-- back menu -->
   <v-btn text
          @click="back"
          v-if="selectedMenu">
     <arrow-left-circle-icon size="1.5x" class="grey--text"></arrow-left-circle-icon>
   </v-btn>

   <v-btn text
          v-for="item in currentMenu"
          :key="item.id"
          @click="openMenu(item)">
     {{ item.label }}
   </v-btn>

   <v-spacer></v-spacer>

   <v-btn icon
          @click="toggleAppMenu"
          v-if="hasOpenApps && !isMobile">
     <v-icon>mdi-apps</v-icon>
   </v-btn>

   <UserMenu/>

   <UserNotifications v-if="!isMobile"/>

 </v-toolbar>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import { ArrowLeftCircleIcon } from 'vue-feather-icons'

  import UserMenu from '@/components/UserMenu'
  import UserNotifications from '@/components/UserNotifications'

  import menuMixin from '@/mixins/menu'
  import utility from '@/mixins/utility'

   export default {
    
    name: 'Header',

    mixins: [ menuMixin, utility ],

    components:
    {
      ArrowLeftCircleIcon,
      UserMenu,
      UserNotifications
    },

    data: () => ({
      
    }),

    computed:
    {
      ...mapGetters({
        menu: 'menu/toolbar',
        hasOpenApps: 'menu/hasOpenApps',
        currentApp: 'menu/currentApp'
      }),

      toolbarCss()
      {
        let css = ''

        if( !this.isMobile )
          css += 'pr-5 '

        // 'grey darken-4'
        if( this.hasOpenApps ) 
          css += 'grey lighten-3'
        else 
          css += 'white'

        return css
      },

      toolbarTitle()
      {
        return this.currentApp ? this.currentApp.label : 'Zwan Spaces'
      }
    },

    methods:
    {
      ...mapActions({
        showAppMenu: 'menu/toggleAppMenu'
      }),

      toggleAppMenu()
      {
        if( this.hasOpenApps )
          this.showAppMenu()
      }
    },

    load(){}
  }
</script>